import { typographySemanticTokens as g } from "../../tokens/typography.mjs";
const i = g["sans-serif"], d = {
  lg: {
    paddingTop: "spacing-4",
    paddingLeft: "spacing-5",
    paddingRight: "spacing-5",
    paddingBottom: "spacing-4",
    borderRadius: "radius-3",
    gap: "spacing-2",
    height: 56,
    ...i.lg,
    fontWeight: "medium"
  },
  md: {
    paddingTop: "spacing-3",
    paddingLeft: "spacing-5",
    paddingRight: "spacing-5",
    paddingBottom: "spacing-3",
    borderRadius: "radius-2,5",
    gap: "spacing-2",
    height: 44,
    ...i.md,
    fontWeight: "medium"
  },
  sm: {
    paddingTop: "spacing-2",
    paddingLeft: "spacing-3",
    paddingRight: "spacing-3",
    paddingBottom: "spacing-2",
    borderRadius: "radius-2",
    gap: "spacing-2",
    height: 32,
    ...i.sm,
    fontWeight: "medium"
  }
};
export {
  d as size
};
